import { appAPI } from '.';
import {
  ImporterPreviewData,
  BulkImportEntityData,
  ImportEntityType,
  ValidationResultType,
} from 'src/components/ClientsImportPage/clientImportTypes';

export enum ImporterStatus {
  INITIALIZED = 'initialized',
  STARTED = 'started',
  COMPLETED = 'completed',
  FAILED = 'failed',
  PROGRESS = 'progress',
  MAPPED = 'mapped',
}

export type ImportProgressDataType = {
  Status: string;
  Progress: {
    Total: number;
    Done: number;
  };
};

type CompanyDetailsType = {
  name: string;
  leadUserID: string;
  assignedUserIDs: Array<string>;
  fallbackColor: string;
  avatarImageUrl: string;
};
export type PreviewClientType = {
  givenName: string;
  familyName: string;
  email: string;
  companyDetails: CompanyDetailsType;
  customFields?: {
    items: any; // TODO add type
  };
};
export type SaveMappingResponse = {
  new: Array<PreviewClientType>;
  skipped: Array<PreviewClientType>;
  updated: Array<PreviewClientType>;
};
export const BULK_IMPORT_DATA_PREVIEW_LIMIT = 4;
const importerApi = appAPI.injectEndpoints({
  endpoints: build => ({
    createBulkImport: build.mutation<
      BulkImportEntityData,
      { s3FileKey: string; importType: ImportEntityType }
    >({
      query: ({ s3FileKey, importType }) => ({
        path: `/importer/create/${importType}`,
        method: 'post',
        options: {
          body: {
            s3FileKey,
          },
        },
      }),
    }),
    getBulkImportPreviewData: build.query<
      ImporterPreviewData,
      { importerId: string }
    >({
      query: ({ importerId }) => ({
        path: `/importer/${importerId}/data`,
        method: 'get',
        options: {
          queryStringParameters: { limit: BULK_IMPORT_DATA_PREVIEW_LIMIT },
        },
      }),
    }),
    validateColumn: build.query<
      ValidationResultType,
      { importerId: string; columnIndex: number; matchFieldName: string }
    >({
      query: ({ importerId, columnIndex, matchFieldName }) => ({
        path: `/importer/${importerId}/validate/${columnIndex}/${matchFieldName}`,
        method: 'get',
        options: {
          queryStringParameters: {},
        },
      }),
    }),
    saveMapping: build.mutation<
      SaveMappingResponse,
      { importerId: string; mapping: Record<string, string> }
    >({
      query: ({ importerId, mapping }) => ({
        path: `/importer/${importerId}/map`,
        method: 'post',
        options: {
          body: {
            Mapping: mapping,
          },
        },
      }),
    }),
    runImporterJob: build.mutation<
      { status: ImporterStatus }, // todo: add type
      { importerId: string; inviteClients: boolean }
    >({
      query: ({ importerId, inviteClients }) => ({
        path: `/importer/${importerId}/run`,
        method: 'post',
        options: {
          body: {
            inviteClients,
          },
        },
      }),
    }),
    getImporterStatus: build.query<
      ImportProgressDataType,
      { importerId: string }
    >({
      query: ({ importerId }) => ({
        path: `/importer/${importerId}/status`,
        method: 'get',
        options: {
          queryStringParameters: {},
        },
      }),
    }),
  }),
});

export const {
  useCreateBulkImportMutation,
  useGetBulkImportPreviewDataQuery,
  useValidateColumnQuery,
  useSaveMappingMutation,
  useRunImporterJobMutation,
  useGetImporterStatusQuery,
} = importerApi;
